import { useState } from 'react';
import { Table, Tag, Card, Statistic, Button, Spin, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faUserPlus, faEye, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

export const ParticipantesTable = ({
    participantes,
    loading,
    onEdit,
    onDelete,
    onViewAsistencias,
    onAssignAsistencia,

    permissionInsert,
    permissionUpdate,
    permissionDelete

}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const cleanParticipantes = participantes.map((p, index) => ({
        ...p,
        asistencias: p.children
            ? p.children.filter(a => a.participa === 1).length
            : 0,
        indexGlobal: index + 1,
    }));


    const paginatedData = cleanParticipantes.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const columns = [
        {
            title: '#',
            key: 'index',
            align: 'center',
            dataIndex: 'indexGlobal',
            width: 50,
        },
        {
            title: 'Participante',
            dataIndex: 'nombre_matriculado',
            key: 'nombre',
            render: (_, record) => (
                <div style={{ padding: '4px 0' }}>
                    <div><strong>{record.nombre_matriculado}</strong></div>
                    <div style={{ fontSize: 12, color: '#888' }}>{record.tipo_documento}: {record.identificacion}</div>
                </div>
            ),
        },
        {
            title: 'Contacto',
            key: 'contacto',
            render: (_, record) => (
                <div style={{ padding: '4px 0' }}>
                    <div style={{ fontSize: 12 }}><FontAwesomeIcon icon={faPhone} /> {record.telefono}</div>
                    <div style={{ fontSize: 12 }}><FontAwesomeIcon icon={faEnvelope} /> {record.email}</div>
                </div>
            ),
        },
        {
            title: 'Cohorte',
            dataIndex: 'cohorte',
            key: 'cohorte',
            align: 'center',
            render: (cohorte) => <Tag>{cohorte}</Tag>,
        },
        {
            title: 'Estado',
            dataIndex: 'activo',
            align: 'center',
            key: 'activo',
            render: (activo) => (
                <Tag color={activo === 'Si' ? 'green' : 'red'}>
                    {activo === 'Si' ? 'Activo' : 'Inactivo'}
                </Tag>
            ),
        },
        {
            title: 'Certificado',
            dataIndex: 'certificado',
            key: 'certificado',
            align: 'center',
            render: (certificado) => (
                <Tag color={certificado === 'Si' ? 'blue' : 'gray'}>
                    {certificado === 'Si' ? 'Certificado' : 'Sin certificar'}
                </Tag>
            ),
        },
        {
            title: 'Asistencias',
            key: 'asistencias',
            render: (_, record) => (
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 'bold' }}>{record.asistencias || 0}
                    </div>
                </div>
            ),
        },
        {
            title: 'Acciones',
            key: 'acciones',
            render: (_, record) => (

                <div style={{ display: 'flex', justifyContent: 'end', gap: 8 }}>
                    <Tooltip title="Ver asistencias"><Button size="small" icon={<FontAwesomeIcon icon={faEye} />} onClick={() => onViewAsistencias(record)} /></Tooltip>
                    {permissionInsert && (<Tooltip title="Asignar asistencia"><Button size="small" icon={<FontAwesomeIcon icon={faUserPlus} />} onClick={() => onAssignAsistencia(record)} /></Tooltip>)}
                    {permissionUpdate && (<Tooltip title="Editar participante"><Button size="small" icon={<FontAwesomeIcon icon={faEdit} />} onClick={() => onEdit(record)} /></Tooltip>)}
                    {permissionDelete && (<Tooltip title="Eliminar participante"><Button size="small" danger icon={<FontAwesomeIcon icon={faTrash} />} onClick={() => onDelete(record.oid)} /></Tooltip>)}
                </div>
            ),
        },
    ];
    const totalAsistencias = participantes.reduce(
        (total, p) => total + (p.children ? p.children.filter(a => a.participa === 1).length : 0),
        0
    );

    if (loading) {
        return (
            <Spin spinning={true} tip="Cargando participantes...">
                <div style={{ height: 200 }} />
            </Spin>
        );
    }
    if (participantes.length === 0) {
        return <div style={{ textAlign: 'center', padding: 20, color: '#888' }}>No se encontraron participantes</div>;
    }
    return (
        <Card
            style={{ padding: 16, textAlign: 'center' }}
        >
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: 16,
                    marginBottom: 24,
                }}
            >
                <Statistic title={<span style={{ fontWeight: 'bold', fontSize: 18 }}>Participantes</span>} value={participantes.length} valueStyle={{ color: '#1677ff', fontWeight: 'bold' }} />
                <Statistic title={<span style={{ fontWeight: 'bold', fontSize: 18 }}>Activos</span>} value={participantes.filter(p => p.activo === 'Si').length} valueStyle={{ color: '#3f8600', fontWeight: 'bold' }} />
                <Statistic title={<span style={{ fontWeight: 'bold', fontSize: 18 }}>Certificados</span>} value={participantes.filter(p => p.certificado === 'Si').length} valueStyle={{ color: '#722ed1', fontWeight: 'bold' }} />
                <Statistic title={<span style={{ fontWeight: 'bold', fontSize: 18 }}>Asistencias</span>} value={totalAsistencias} valueStyle={{ color: '#fa8c16', fontWeight: 'bold' }} />
            </div>

            <Table
                dataSource={paginatedData}
                columns={columns}
                rowKey="oid"
                bordered
                expandable={{
                    expandIcon: () => null,
                }}
                size="middle"
                style={{ marginBottom: 16 }}
                scroll={{ x: 'max-content' }}
                pagination={{
                    current: currentPage,
                    total: cleanParticipantes.length,
                    pageSize: itemsPerPage,
                    onChange: handlePageChange,
                    showSizeChanger: false,
                }}
            />
        </Card>
    );
};

export default ParticipantesTable;
